import moment from 'moment';
import Transformer from '../Transformer';
import { CLEANER_BASE } from '../../constants/roles';

const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

export default class CleanerTransformer extends Transformer {
  /**
   * Method used to transform a fetched account.
   *
   * @param cleaner The fetched cleaner.
   *
   * @returns {Object} The transformed account.
   */
  static fetch(cleaner) {
    if (cleaner.carier_start_at.length > 0) {
      // eslint-disable-next-line no-param-reassign
      cleaner.carier_start_at = moment(cleaner.carier_start_at, DEFAULT_DATE_FORMAT);
    }
    return cleaner;
  }

  /**
   * Method used to transform a send account.
   *
   * @param cleaner The cleaner to be send.
   *
   * @returns {Object} The transformed account.
   */
  static send(cleaner) {
    const data = {
      active: cleaner.active,
      has_inventory: cleaner.has_inventory,
      additional_info: cleaner.additional_info,
      name: cleaner.name,
      address: cleaner.address,
      note: cleaner.note,
      card_text: cleaner.card_text,
      card_number: cleaner.card_number,
      phone: cleaner.phone,
      role: cleaner.role,
      roles: cleaner.roles,
      region: cleaner.region,
      password: cleaner.password,
      email: cleaner.email,
    };
    if (cleaner.carier_start_at) {
      data.carier_start_at = cleaner.carier_start_at.format(DEFAULT_DATE_FORMAT);
    }
    if (cleaner.role === CLEANER_BASE && cleaner.rank && cleaner.rank.length > 0) {
      data.rank = cleaner.rank;
    }

    if (cleaner.new_avatar) {
      data.new_avatar = cleaner.new_avatar;
    }

    return data;
  }
}
